import { render, staticRenderFns } from "./NotificationToast.vue?vue&type=template&id=c987d7ea&"
import script from "./NotificationToast.ts?vue&type=script&lang=ts&"
export * from "./NotificationToast.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports